import styled from "styled-components";

export const FloatButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #007bff, var(--primary));
  border: none;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(0, 123, 255, 0.4);
  z-index: 1000;
  transition: all 0.3s ease;
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  transform: ${(props) => (props.isVisible ? "scale(1)" : "scale(0)")};

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 25px rgba(0, 123, 255, 0.5);
  }

  &:active {
    transform: scale(0.95);
  }

  @media (max-width: 768px) {
    width: 56px;
    height: 56px;
    bottom: 75px;
    right: 10px;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
  backdrop-filter: blur(2px);

  @media (min-width: 769px) {
    display: none;
  }
`;

export const ChatContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 400px;
  height: 600px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.15);
  z-index: 1001;
  display: flex;
  flex-direction: column;
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  transform: ${(props) =>
    props.isOpen ? "translateY(0) scale(1)" : "translateY(20px) scale(0.95)"};
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  pointer-events: ${(props) => (props.isOpen ? "auto" : "none")};

  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border-radius: 0;
    transform: ${(props) =>
      props.isOpen ? "translateY(0)" : "translateY(100%)"};
  }
`;

export const ChatHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  border-radius: 16px 16px 0 0;

  @media (max-width: 768px) {
    border-radius: 0;
    padding: 20px 20px 16px 20px;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AgentInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AgentSubtitle = styled.span`
  font-size: 12px;
  opacity: 0.8;
  color: #fff;
`;

export const ActionButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.05);
  }
`;

export const VersionSelectorContainer = styled.div`
  position: relative;
`;

export const VersionSelectorButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  transition: all 0.2s ease;
  backdrop-filter: blur(10px);

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  ${(props) =>
    props.isActive &&
    `
    background: rgba(255, 255, 255, 0.3);
  `}
`;

export const VersionDropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  z-index: 1000;
  overflow: hidden;
  border: 1px solid #e9ecef;
`;

export const VersionDropdownHeader = styled.div`
  padding: 12px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  font-size: 12px;
  color: #6c757d;
`;

export const VersionOption = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.2s ease;
  color: #333;

  &:hover {
    background: #f8f9fa;
  }

  ${(props) =>
    props.isSelected &&
    `
    background: #e3f2fd;
    color: #1976d2;
  `}
`;

export const VersionInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const VersionLabel = styled.div`
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const VersionDate = styled.div`
  font-size: 11px;
  opacity: 0.7;
`;

export const CurrentBadge = styled.span`
  background: #4caf50;
  color: white;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 500;
`;

export const InfoBar = styled.div`
  background: ${(props) => (props.hasIssues ? "#fff3cd" : "#e3f2fd")};
  padding: 8px 16px;
  border-bottom: 1px solid
    ${(props) => (props.hasIssues ? "#ffeaa7" : "#bbdefb")};
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const InfoText = styled.div`
  font-size: 12px;
  color: #1565c0;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const StatsText = styled.div`
  font-size: 11px;
  color: #666;
  opacity: 0.8;
`;

export const FunctionBadge = styled.span`
  background: #4caf50;
  color: white;
  padding: 2px 6px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 500;
`;

export const ErrorBadge = styled.span`
  background: #f44336;
  color: white;
  padding: 2px 6px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const WarningBadge = styled.span`
  background: #ff9800;
  color: white;
  padding: 2px 6px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const RobotIcon = styled.div`
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
`;

export const AgentName = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
`;

export const CloseButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
  }
`;

export const MessagesContainer = styled.div`
  flex: 1;
  padding: 16px;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  overflow: hidden;

  .ps__rail-y {
    opacity: 0.6;
  }
`;

export const MessagesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 100%;
`;

export const MessageBubble = styled.div`
  max-width: 80%;
  align-self: ${(props) => (props.isUser ? "flex-end" : "flex-start")};
  background: ${(props) => {
    if (props.isError) return "linear-gradient(135deg, #ff6b6b, #ee5a52)";
    if (props.isSystem) return "linear-gradient(135deg, #17a2b8, #138496)";
    return props.isUser
      ? "linear-gradient(135deg, rgb(220, 248, 198), rgb(225 237 208))"
      : "white";
  }};
  color: ${(props) =>
    props.isUser || props.isError || props.isSystem ? "#1a1a1a" : "#333"};
  padding: 12px 16px;
  border-radius: ${(props) =>
    props.isUser ? "16px 4px 16px 16px" : "4px 16px 16px 16px"};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  word-wrap: break-word;
  position: relative;
  border: ${(props) => (props.isUser ? "none" : "1px solid #e9ecef")};
`;

export const MessageText = styled.div`
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 4px;
  white-space: pre-wrap;
  ${(props) =>
    props.isSystem &&
    `
    font-style: italic;
    opacity: 0.9;
  `}
`;

export const MessageTime = styled.div`
  font-size: 11px;
  opacity: 0.7;
  text-align: right;
`;

export const TypingIndicator = styled.div`
  max-width: 80%;
  align-self: flex-start;
  background: white;
  padding: 12px 16px;
  border-radius: 4px 16px 16px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: -6px;
    top: 12px;
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-right-color: white;
  }
`;

export const TypingDots = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 4px;

  span {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #007bff;
    animation: typing 1.4s infinite;

    &:nth-child(2) {
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }

  @keyframes typing {
    0%,
    60%,
    100% {
      transform: translateY(0);
      opacity: 0.5;
    }
    30% {
      transform: translateY(-10px);
      opacity: 1;
    }
  }
`;

export const InputContainer = styled.div`
  padding: 16px;
  background: white;
  border-radius: 0 0 16px 16px;
  border-top: 1px solid #e9ecef;

  @media (max-width: 768px) {
    border-radius: 0;
    padding: 16px 16px 20px 16px;
  }
`;

export const MessageInputWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

export const MessageInput = styled.textarea`
  flex: 1;
  border: 2px solid #e9ecef;
  border-radius: 20px;
  padding: 12px 16px;
  outline: none;
  resize: none;
  max-height: 100px;
  min-height: 44px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.4;
  background: #f8f9fa;
  transition: all 0.2s ease;

  &:focus {
    border-color: #007bff;
    background: white;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
  }

  &::placeholder {
    color: #6c757d;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 4px;
`;

export const SendButton = styled.button`
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
  background: ${(props) =>
    props.disabled
      ? "#e9ecef"
      : "linear-gradient(135deg, rgb(37, 211, 102), rgb(18, 140, 126))"};
  color: ${(props) => (props.disabled ? "#6c757d" : "white")};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
  }

  &:active:not(:disabled) {
    transform: scale(0.95);
  }
`;

export const LoadingNote = styled.div`
  text-align: center;
  font-size: 12px;
  color: #6c757d;
  padding: 8px;
  font-style: italic;
`;

